import axios from "axios";
import { toast } from "react-toastify";

export const handleAxiosError = (
  error,
  options = {}
) => {
  const {
    customMessage,
    defaultMessage = "An error occurred. Please try again.",
    showToast = true,
    logError = true,
    onError,
  } = options;

  const errorMessage =
    customMessage ||
    (axios.isAxiosError(error)
      ? error?.response?.data?.message ||
        error?.response?.data?.errorDescription ||
        error?.response?.data?.error ||
        error?.message
      :  defaultMessage);

  if (logError) {
    console.error("Error:", error);
    console.error("Error message:", errorMessage);
  }

  if (onError) {
    onError(error, errorMessage);
  }

  if (showToast) {
    toast.error(errorMessage);
  }

  return errorMessage;
};
